import { render, staticRenderFns } from "./BDR.vue?vue&type=template&id=06ee1b5c&scoped=true&"
import script from "./BDR.vue?vue&type=script&lang=js&"
export * from "./BDR.vue?vue&type=script&lang=js&"
import style0 from "./BDR.vue?vue&type=style&index=0&id=06ee1b5c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06ee1b5c",
  null
  
)

export default component.exports